import React from 'react'
import { Col, Nav, Row, Tab } from 'react-bootstrap'
import GeneralSettings from './Settings Tabs/GeneralSettings'
import SystemSettings from './Settings Tabs/SystemSettings'

const Settings = () => {
    return (
        <div className="page-wrapper">
            <div className="content">
                <Tab.Container id="left-tabs-example" defaultActiveKey="generalSettings">
                    <Row>
                        <div className='card card-css'>
                            <div className='card-body p-2'>
                                <h4 className='color-red mb-3'>
                                    Settings
                                </h4>
                                <Col sm={12} className='p-0'>

                                    <Nav>
                                        <Nav.Item>
                                            <Nav.Link className='nav-tabs' eventKey="generalSettings">General Settings</Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item>
                                            <Nav.Link className='nav-tabs' eventKey="systemSettings">System Settings</Nav.Link>
                                        </Nav.Item>
                                    </Nav>
                                </Col>
                            </div>
                        </div>

                        <Col sm={12} className='p-0'>
                            <Tab.Content>
                                <Tab.Pane eventKey="generalSettings"><GeneralSettings/></Tab.Pane>
                                <Tab.Pane eventKey="systemSettings"><SystemSettings/></Tab.Pane>
                            </Tab.Content>
                        </Col>
                    </Row>
                </Tab.Container>

            </div>
        </div>
    )
}

export default Settings